import { FiSearch } from "react-icons/fi";
import classes from "./SearchInput.module.css";

const SearchInput = ({ value, onChange, placeholder, onClick }) => {
    return(
         <div className={`d-flex align-items-center gap-2 ${classes.searchInput}`}>
              <FiSearch size={20} color="#667085" />
              <input
                type="text"
                placeholder={placeholder}
                value={value}
                onChange={onChange}
              />
              {onClick && <button type="button" onClick={onClick}>GO</button>}
            </div>
    )
}

export default SearchInput;